"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = exports.DownloadUtil = void 0;
var DownloadUtil = function (data, filename, type) {
    if (filename === void 0) { filename = 'CSV'; }
    if (type === void 0) { type = 'application/json'; }
    var blob = new Blob([data], { type: type });
    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
    }
    else {
        var downloadElement = document.createElement('a');
        var objectUrl = URL.createObjectURL(blob);
        downloadElement.href = objectUrl;
        downloadElement.download = filename;
        downloadElement.click();
    }
    return data;
};
exports.DownloadUtil = DownloadUtil;
exports.default = exports.DownloadUtil;
//# sourceMappingURL=DownloadUtil.js.map